import { useQuery } from '@tanstack/react-query';

import { queries } from '../api/queryKeys/queries';

export const useVesselProducts = (vesselId?: string) => {
    return useQuery({
        ...queries.vessels.detail(vesselId || '')._ctx.products,
        enabled: !!vesselId,
    });
};
